import React from 'react';

import { DefaultHelpPage } from './DefaultHelpPage';

export const SqHelpPage: React.FC = () => <DefaultHelpPage />;
